/**
 * Staged-upload queue, stored in the compose item's sessionData.
 *
 * sessionData is per-compose-item — unlike roamingSettings, which is mailbox-
 * global. Each open draft has its own queue, so two open compose windows can
 * never read or clobber each other's staged files, and the queue is gone once
 * the draft is sent or closed. Stored as one JSON-string key. Requires Mailbox
 * 1.11.
 */

const QUEUE_KEY = "leapfile_staged_queue"; // JSON [{ id, name, size, status, oid }]

function sessionData() {
  const item = Office.context.mailbox && Office.context.mailbox.item;
  return item && item.sessionData ? item.sessionData : null;
}

/** This compose item's staged entries (or []). */
export function getQueue() {
  return new Promise((resolve) => {
    const data = sessionData();
    if (!data) return resolve([]);
    data.getAsync(QUEUE_KEY, (res) => {
      if (res.status !== Office.AsyncResultStatus.Succeeded || !res.value) return resolve([]);
      try {
        const parsed = JSON.parse(res.value);
        resolve(Array.isArray(parsed) ? parsed : []);
      } catch {
        resolve([]);
      }
    });
  });
}

/** Replace this item's staged entries; resolves once saved. */
export function setQueue(entries) {
  return new Promise((resolve) => {
    const data = sessionData();
    if (!data) return resolve();
    data.setAsync(QUEUE_KEY, JSON.stringify(entries || []), () => resolve());
  });
}

/** Drop this item's staged queue; resolves once saved. */
export function clearQueue() {
  return new Promise((resolve) => {
    const data = sessionData();
    if (!data) return resolve();
    data.removeAsync(QUEUE_KEY, () => resolve());
  });
}
